// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".privacy[data-v-0cdb2632]{font-size:.75rem}.free-month-nofitication[data-v-0cdb2632]{font-size:.875rem;text-align:center}@media screen and (max-width:768px){.free-month-nofitication[data-v-0cdb2632]{padding:.625rem .9375rem}}@media print,screen and (min-width:769px){.free-month-nofitication[data-v-0cdb2632]{font-size:1rem;text-align:left}}h1[data-v-0cdb2632]{margin-bottom:.5rem}p[data-v-0cdb2632]{margin-bottom:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
